<template>
  <div class="container-fluid page-content">
    <register-product-step1></register-product-step1>
  </div>
</template>

<script>
  import RegisterProductStep1 from '@/components/registerStep1'
  import scrollToElement from 'scroll-to-element'

  export default {
    name: 'ProductRegistrationStep1',
    components: {
      RegisterProductStep1
    },
    mounted () {
      window.onbeforeunload = function () {
        return window.confirm('Changes you made may not be saved')
      }

      scrollToElement('.page-content', {
        offset: 0,
        ease: 'out-cube',
        duration: 800
      });
    }
  }
</script>

<style lang="scss" scoped>
  .page-content {
    padding-top: 50px;
    padding-bottom: 50px;
  }
</style>
